// @ngInject
function percentInput($filter) {
    var onViewChange = function(viewValue) {
        var m = viewValue.match(/^(\d+)\/(\d+)/);
        if (m != null) {
          var newValueParsed = $filter('number')(parseInt(m[1])/parseInt(m[2]), 2);
          newValueParsed = newValueParsed.replace(/,/, '.');
          return newValueParsed;
        }
        var newValueUnparsed = $filter('number')(parseFloat(viewValue) / 100, 2);
        newValueUnparsed = newValueUnparsed.replace(/,/, '.');
        return newValueUnparsed;
    };

    var onModelChange = function(modelValue) {
        var newValue = $filter('number')(parseFloat(modelValue) * 100);
        newValue = newValue.replace(/,/, '.');
        return newValue;
    };

    return {
        require: 'ngModel',
        link: function(scope, ele, attr, ctrl) {
            ctrl.$parsers.unshift(onViewChange);
            ctrl.$formatters.unshift(onModelChange);
        }
    };
}

angular
    .module('directives.percentInput', [])
    .directive("percentInput", percentInput);
